// Meta
export const REQUEST_META_INFO = "REQUEST_META_INFO";

// Security
export const REQUEST_EXCHANGE_TOKEN = "REQUEST_EXCHANGE_TOKEN";
export const REQUEST_TOKEN = "REQUEST_TOKEN";
export const RENEW_TOKEN = "RENEW_TOKEN";

// Content
export const REQUEST_TEMPLATES = "REQUEST_TEMPLATES";
export const UPDATE_TEMPLATE = "UPDATE_TEMPLATE";
export const UPDATE_TEMPLATES = "UPDATE_TEMPLATES";

// Videos
export const FETCH_TAGS = "FETCH_TAGS";
export const FETCH_VIDEOS = "FETCH_VIDEOS";
export const ADD_TAG = "ADD_TAG";
export const UPDATE_TAG = "UPDATE_TAG";
export const DELETE_TAG = "DELETE_TAG";
export const FETCH_VIDEO_SOURCES = "FETCH_VIDEO_SOURCES";
export const UPLOAD_THUMBNAIL = "UPLOAD_THUMBNAIL";
export const ADD_VIDEO = "ADD_VIDEO";
export const UPDATE_VIDEO = "UPDATE_VIDEO";
export const DELETE_VIDEO = "DELETE_VIDEO";

// Video
export const FETCH_VIDEO = "FETCH_VIDEO";
export const FETCH_VIDEO_SUGGESTIONS = "FETCH_VIDEO_SUGGESTIONS";

// Messages
export const REQUEST_MESSAGES = "REQUEST_MESSAGES";
export const REQUEST_MESSAGE = "REQUEST_MESSAGE";
export const REQUEST_FAVORED_MESSAGES = "REQUEST_FAVORED_MESSAGES";
export const ADD_MESSAGE = "ADD_MESSAGE";
export const UPDATE_MESSAGE = "UPDATE_MESSAGE";
export const DELETE_MESSAGE = "DELETE_MESSAGE";

// Program
export const REQUEST_BLOCKS = "REQUEST_BLOCKS";
export const ADD_PROGRAM_BLOCK = "ADD_PROGRAM_BLOCK";
export const UPDATE_PROGRAM_BLOCK = "UPDATE_PROGRAM_BLOCK";
export const SWAP_PROGRAM_BLOCKS = "SWAP_PROGRAM_BLOCKS";
export const DELETE_PROGRAM_BLOCK = "DELETE_PROGRAM_BLOCK";
export const REQUEST_PROGRAM = "REQUEST_PROGRAM";
export const ADD_PROGRAM_ITEM = "ADD_PROGRAM_ITEM";
export const UPDATE_PROGRAM_ITEM = "UPDATE_PROGRAM_ITEM";
export const DELETE_PROGRAM_ITEM = "DELETE_PROGRAM_ITEM";

// Statistics
export const REQUEST_GLOBAL_STATISTICS = "REQUEST_GLOBAL_STATISTICS";
export const REQUEST_VIDEO_STATISTICS = "REQUEST_VIDEO_STATISTICS";
export const REQUEST_VIDEOS_STATISTICS = "REQUEST_VIDEOS_STATISTICS";
export const REQUEST_MESSAGES_STATISTICS = "REQUEST_MESSAGES_STATISTICS";
export const REQUEST_VIDEOS_RANK = "REQUEST_VIDEOS_RANK";
export const REQUEST_MESSAGES_RANK = "REQUEST_MESSAGES_RANK";
export const REQUEST_USERS_RANK = "REQUEST_USERS_RANK";
export const REQUEST_CUSTOM_RANK = "REQUEST_CUSTOM_RANK";

// Events
export const REQUEST_EVENTS = "REQUEST_EVENTS";

// Users
export const REQUEST_USERS = "REQUEST_USERS";
export const REQUEST_USER = "REQUEST_USER";
export const REQUEST_AUTHORITIES = "REQUEST_AUTHORITIES";
export const ADD_USER = "ADD_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";

// Diagnostics
export const REQUEST_AVAILABLE_METRICS = "REQUEST_AVAILABLE_METRICS";
export const REQUEST_METRICS = "REQUEST_METRICS";
export const REQUEST_DIAGNOSTICS = "REQUEST_DIAGNOSTICS";

// action types will be defined here
